import React from "react";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PhoneIcon from "@mui/icons-material/Phone";
import bfLogo from "../../../assets/images/utsav-pack-logo.png";
import { Link } from "@mui/material";
import BouncyMapPin from "../../../animations/BouncyMapPin";

const ContactUS = () => {
  return (
    <Box sx={{ p: 6 }}>
      <Grid container justifyContent="center">
        {/* Logo */}
        <Grid item xs={12} sm={8} md={6} textAlign="center">
          <img
            src={bfLogo}
            alt="Utsav Pack"
            style={{ width: "100%", maxWidth: 280 }}
          />
          <Typography
            variant="h5"
            fontWeight="bolder"
            fontSize="25px"
            sx={{ m: 1 }}
          >
            UTSAV PACK
          </Typography>

          <Typography>
            <Link
              href="#"
              underline="hover"
              color="inherit"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                "&:hover": {
                  color: "var(--primary-red-base)",
                  textDecoration: "none",
                },
              }}
            >
              <Box sx={{ transform: "scale(0.9)", display: "inline-flex" }}>
                <BouncyMapPin />
              </Box>
              <span>
                I-4, VNCT Lotus Villas, Puthuthamaraipatti, <br />
                Madurai, Tamil Nadu - 625107
              </span>
            </Link>
          </Typography>

          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              mt: 1,
            }}
          >
            <PhoneIcon
              fontSize="small"
              sx={{
                mr: 2,
                color: "var(--primary-red-base)",
                animation: "vibrate 0.4s infinite",
                "@keyframes vibrate": {
                  "0%": { transform: "rotate(0deg)" },
                  "25%": { transform: "rotate(15deg)" },
                  "50%": { transform: "rotate(-15deg)" },
                  "75%": { transform: "rotate(15deg)" },
                  "100%": { transform: "rotate(0deg)" },
                },
              }}
            />
            <Link
              href="tel:+918489811444"
              underline="hover"
              color="inherit"
              sx={{
                "&:hover": {
                  color: "var(--primary-red-base)",
                },
              }}
            >
            +91 84898 11444
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactUS;
